import React from "react";
import { RECOMMENDATION_CASES } from "./recommendationCases";

export function RecommendationCaseChip({ caseType }) {
    const { label, modifier } = RECOMMENDATION_CASES[caseType];

    return (
        <span
            data-testid="recommendation-case-chip"
            className={`recommendation-case-chip recommendation-case-chip--${modifier}`}>
            {label}
        </span>
    );
}
